var map = {
	"./CO2.svg": 49108,
	"./DMS.svg": 11228,
	"./ELD.svg": 3769,
	"./Exclude.svg": 77466,
	"./Ice-cream.svg": 92908,
	"./Icon_Button_Editable.svg": 95193,
	"./Icon_Button_Not Editable.svg": 34480,
	"./Icon_No Visible.svg": 3161,
	"./Icon_Visible.svg": 16144,
	"./MD-orange.svg": 29254,
	"./X.svg": 324,
	"./access-is-denied.svg": 59365,
	"./access-right.svg": 16699,
	"./address-location.svg": 70140,
	"./air.svg": 51520,
	"./alcoholic_drinks_bottle.svg": 53951,
	"./america.svg": 24496,
	"./arrow-bottom-top.svg": 9375,
	"./arrow-down.svg": 26292,
	"./arrow-left.svg": 29267,
	"./arrow-push.svg": 41692,
	"./arrow-right.svg": 48150,
	"./arrow-top.svg": 98849,
	"./asset-utilization-report.svg": 3686,
	"./avoidable_operating_costs.svg": 95196,
	"./basket.svg": 8346,
	"./battery-lvl-100.svg": 69508,
	"./battery-lvl-25.svg": 82040,
	"./battery-lvl-50.svg": 91704,
	"./battery-lvl-75.svg": 51691,
	"./battery-report.svg": 72178,
	"./biochemical.svg": 22334,
	"./ble_tag.svg": 1554,
	"./bluetooth-icon-90.svg": 6326,
	"./bluetooth-icon.svg": 78172,
	"./bluetooth-indicator.svg": 9518,
	"./bluetooth-rotate-90.svg": 39208,
	"./bluetooth-station.svg": 47733,
	"./bluetooth.svg": 69442,
	"./bread.svg": 22470,
	"./build-track.svg": 38726,
	"./butter.svg": 39922,
	"./button_edit.svg": 18867,
	"./button_units_on_map.svg": 62911,
	"./cakes.svg": 71923,
	"./calendar.svg": 7590,
	"./camera-offline.svg": 40127,
	"./camera-online.svg": 94035,
	"./camera.svg": 16049,
	"./camera_id.svg": 92579,
	"./camera_type.svg": 19788,
	"./car-back.svg": 57502,
	"./car-front.svg": 24664,
	"./car-l-side.svg": 35163,
	"./car-r-side.svg": 28641,
	"./car.svg": 90918,
	"./car_.svg": 349,
	"./cargo-temperature.svg": 82489,
	"./cargo.svg": 12328,
	"./catscale.svg": 31222,
	"./cell_tower.svg": 622,
	"./charge.svg": 12800,
	"./chart-line.svg": 59267,
	"./chart-schedule.svg": 34566,
	"./chart.svg": 42204,
	"./chassis.svg": 51720,
	"./checkbox_bold.svg": 39299,
	"./checkbox_checked.svg": 27165,
	"./cheese.svg": 96155,
	"./chocolates.svg": 48541,
	"./circle-done.svg": 8009,
	"./circle-wait.svg": 48130,
	"./circle__BLE-connect.svg": 33980,
	"./circle__BLE-disconnect.svg": 26768,
	"./circle___geozone_circle.svg": 17925,
	"./circle___geozone_circle_hidden.svg": 77964,
	"./circle__a-point.svg": 64914,
	"./circle__accelerate.svg": 88133,
	"./circle__b-point.svg": 88833,
	"./circle__clock-2.svg": 17917,
	"./circle__clock.svg": 34416,
	"./circle__coords.svg": 8512,
	"./circle__d-point.svg": 27279,
	"./circle__hidden.svg": 82706,
	"./circle__hourglass.svg": 18832,
	"./circle__link.svg": 26514,
	"./circle__lost-connection.svg": 46905,
	"./circle__low-battery.svg": 94576,
	"./circle__max-speed.svg": 26686,
	"./circle__message.svg": 11415,
	"./circle__mileage.svg": 95118,
	"./circle__movement.svg": 36381,
	"./circle__number.svg": 7209,
	"./circle__parking.svg": 30198,
	"./circle__pin.svg": 71183,
	"./circle__radius.svg": 13260,
	"./circle__satellit-2.svg": 24157,
	"./circle__satellit.svg": 52144,
	"./circle__shock.svg": 59580,
	"./circle__shown.svg": 76421,
	"./circle__signal.svg": 17650,
	"./circle__speed.svg": 62747,
	"./circle__speed_lg.svg": 73357,
	"./circle__steering-wheel.svg": 19541,
	"./circle__stop.svg": 90322,
	"./circle__turn.svg": 29679,
	"./circle__video-event.svg": 82872,
	"./clock.svg": 52878,
	"./close.svg": 36456,
	"./collapse.svg": 99353,
	"./command__active.svg": 81743,
	"./command__block.svg": 42548,
	"./command__delete.svg": 91400,
	"./command__edit.svg": 34357,
	"./command__follow.svg": 87114,
	"./command__history-key.svg": 86133,
	"./command__history-order.svg": 6224,
	"./command__history.svg": 79263,
	"./command__key_revoke.svg": 98567,
	"./command__key_suspend.svg": 27783,
	"./command__password.svg": 80918,
	"./command__refresh.svg": 42874,
	"./command__restore.svg": 2761,
	"./command__sign_in_admin.svg": 86084,
	"./command__sign_in_portal.svg": 41881,
	"./command__update_key.svg": 1186,
	"./common__add.svg": 71266,
	"./common__add_lg.svg": 57618,
	"./common__add_sm.svg": 73821,
	"./common__boat.svg": 11771,
	"./common__boat_lg.svg": 79341,
	"./common__bus.svg": 8913,
	"./common__bus_lg.svg": 58663,
	"./common__buy.svg": 82232,
	"./common__car.svg": 68177,
	"./common__car_lg.svg": 167,
	"./common__chat.svg": 43991,
	"./common__checkbox.svg": 12270,
	"./common__checkbox_all.svg": 48078,
	"./common__chevron_down.svg": 27133,
	"./common__chevron_left.svg": 68934,
	"./common__chevron_left_double.svg": 53406,
	"./common__chevron_right.svg": 63365,
	"./common__chevron_right_double.svg": 32159,
	"./common__chevron_up.svg": 98466,
	"./common__clear_lg.svg": 74504,
	"./common__clear_sm.svg": 37971,
	"./common__close.svg": 92851,
	"./common__close_sm.svg": 34486,
	"./common__collapse.svg": 42264,
	"./common__command.svg": 87376,
	"./common__complex.svg": 10891,
	"./common__complex_lg.svg": 79197,
	"./common__copy.svg": 80742,
	"./common__copy_sm.svg": 59481,
	"./common__delete.svg": 38912,
	"./common__delete_lg.svg": 12252,
	"./common__delete_sm.svg": 72111,
	"./common__docs.svg": 18236,
	"./common__dry_tanker.svg": 24114,
	"./common__dry_trailer.svg": 12460,
	"./common__dry_trailer_lg.svg": 61448,
	"./common__edit.svg": 33709,
	"./common__edit_lg.svg": 50899,
	"./common__email.svg": 59515,
	"./common__engine.svg": 54999,
	"./common__engine_lg.svg": 26201,
	"./common__exit.svg": 53393,
	"./common__export.svg": 27539,
	"./common__export_sm.svg": 90294,
	"./common__favorite.svg": 24169,
	"./common__filter.svg": 1639,
	"./common__filter_on.svg": 47965,
	"./common__follow_sm.svg": 72813,
	"./common__ftp.svg": 25905,
	"./common__fuel_tank.svg": 51672,
	"./common__fuel_tank_lg.svg": 27876,
	"./common__fuel_tanker.svg": 42013,
	"./common__fuel_tanker_lg.svg": 4259,
	"./common__generator.svg": 68456,
	"./common__generator_lg.svg": 94356,
	"./common__geozone_all-geozones.svg": 64727,
	"./common__geozone_circle.svg": 13845,
	"./common__geozone_corridor.svg": 82115,
	"./common__geozone_polygon.svg": 23261,
	"./common__history.svg": 887,
	"./common__ignition.svg": 39852,
	"./common__import_export.svg": 80551,
	"./common__info.svg": 60613,
	"./common__info1.svg": 4558,
	"./common__info_link.svg": 20392,
	"./common__jet_ski.svg": 42300,
	"./common__jet_ski_lg.svg": 68984,
	"./common__line-close.svg": 49872,
	"./common__location.svg": 39476,
	"./common__locator.svg": 79989,
	"./common__menu_sm.svg": 30603,
	"./common__more.svg": 39730,
	"./common__more_vertical.svg": 32935,
	"./common__motorcycle.svg": 48162,
	"./common__motorcycle_lg.svg": 86290,
	"./common__movement.svg": 85078,
	"./common__notice.svg": 83657,
	"./common__notice_disabled.svg": 85188,
	"./common__online_notifications.svg": 47049,
	"./common__parking.svg": 71971,
	"./common__password.svg": 69198,
	"./common__pin.svg": 41254,
	"./common__pin_disabled.svg": 99821,
	"./common__plant_machine.svg": 4490,
	"./common__plant_machine_lg.svg": 66218,
	"./common__print_sm.svg": 84065,
	"./common__pump.svg": 57803,
	"./common__pump_lg.svg": 7389,
	"./common__reefer_gt.svg": 8956,
	"./common__reefer_gt_lg.svg": 8376,
	"./common__reefer_trailer.svg": 38130,
	"./common__reefer_trailer_lg.svg": 24514,
	"./common__remove_lg.svg": 78595,
	"./common__remove_sm.svg": 30268,
	"./common__reports.svg": 95654,
	"./common__resend_sm.svg": 58351,
	"./common__rv.svg": 70397,
	"./common__rv_lg.svg": 94019,
	"./common__server-connection.svg": 45661,
	"./common__server-critical-connection.svg": 70503,
	"./common__server-no-connection.svg": 83569,
	"./common__settings.svg": 90922,
	"./common__show.svg": 18386,
	"./common__show_disabled.svg": 37913,
	"./common__show_partially.svg": 41117,
	"./common__signal.svg": 23521,
	"./common__signal_lost.svg": 65886,
	"./common__slider.svg": 30702,
	"./common__stationary_unit.svg": 59368,
	"./common__stationary_unit_lg.svg": 20244,
	"./common__status_favorite.svg": 52542,
	"./common__status_not_notify.svg": 82047,
	"./common__status_not_show.svg": 87935,
	"./common__status_notice_close.svg": 52995,
	"./common__status_pin.svg": 38511,
	"./common__status_tracking.svg": 59473,
	"./common__support.svg": 61642,
	"./common__tank.svg": 52629,
	"./common__tank_lg.svg": 49131,
	"./common__track.svg": 92126,
	"./common__track_day.svg": 27745,
	"./common__tracking.svg": 91322,
	"./common__tracking_disabled.svg": 14081,
	"./common__tractor.svg": 57238,
	"./common__tractor_lg.svg": 97222,
	"./common__train.svg": 41793,
	"./common__train_lg.svg": 60599,
	"./common__truck.svg": 35042,
	"./common__truck_lg.svg": 86578,
	"./common__upgrade.svg": 46675,
	"./common__user.svg": 352,
	"./common__user_sm.svg": 48815,
	"./common__van.svg": 66508,
	"./common__van_lg.svg": 48680,
	"./common__video.svg": 35994,
	"./common__warning.svg": 67743,
	"./common__water_tanker.svg": 17032,
	"./common__water_tanker_lg.svg": 26580,
	"./common__zoom.svg": 27756,
	"./cookies.svg": 86945,
	"./customization.svg": 55391,
	"./danger.svg": 47349,
	"./device_type.svg": 25385,
	"./direction_track.svg": 98247,
	"./dns-error.svg": 83924,
	"./document.svg": 23759,
	"./dot_scales.svg": 99965,
	"./double-arrow-left.svg": 80635,
	"./double-arrow-right.svg": 57438,
	"./download-video-2.svg": 80091,
	"./download-video.svg": 55162,
	"./download.svg": 81468,
	"./download_documents.svg": 82147,
	"./driver-1.svg": 81564,
	"./driver-icon.svg": 94704,
	"./driver.svg": 80070,
	"./driver_assigned.svg": 90805,
	"./drivers-score-card.svg": 7667,
	"./edit_access.svg": 54017,
	"./edit_camera.svg": 88498,
	"./edit_details.svg": 59527,
	"./edit_keys.svg": 52191,
	"./edit_notes.svg": 12142,
	"./edit_orchestrator.svg": 59083,
	"./edit_specs.svg": 4109,
	"./eggs.svg": 19586,
	"./eld_battery.svg": 38179,
	"./eld_clock.svg": 82054,
	"./eld_driver.svg": 27182,
	"./eld_status_D.svg": 24247,
	"./eld_status_S.svg": 81320,
	"./employe.svg": 8259,
	"./empty.svg": 88591,
	"./engine.svg": 42554,
	"./engine_badge.svg": 95870,
	"./error-image-photo-icon.svg": 11197,
	"./eta-fill.svg": 75598,
	"./eta-track.svg": 25470,
	"./eta.svg": 61724,
	"./event_temperature.svg": 36867,
	"./expand.svg": 11284,
	"./favorite.svg": 98760,
	"./file-color.svg": 67120,
	"./file.svg": 91838,
	"./fish.svg": 2578,
	"./flowers.svg": 37592,
	"./from.svg": 81692,
	"./fruits.svg": 74685,
	"./fuel-filling.svg": 58054,
	"./fuel.svg": 2504,
	"./general-status.svg": 62492,
	"./generator-off.svg": 86011,
	"./generator-ok.svg": 6658,
	"./generator-powel-grid.svg": 30230,
	"./generator-switch.svg": 95624,
	"./geozone-group.svg": 28623,
	"./geozones-no-visits-report.svg": 4244,
	"./geozones-visits-report.svg": 33584,
	"./gps.svg": 15768,
	"./group-on-map.svg": 99944,
	"./head__logo.svg": 22961,
	"./help__add_car_icon.svg": 21001,
	"./help__geoitems1_icon.svg": 52817,
	"./help__geoitems_icon.svg": 63150,
	"./help__login_icon.svg": 69970,
	"./help__notices_icon.svg": 18278,
	"./help__settings_icon.svg": 32768,
	"./help__track_icon.svg": 83700,
	"./help__unit_icon.svg": 69811,
	"./http-no-ssl.svg": 78273,
	"./http-ssl.svg": 47781,
	"./https-no-ssl.svg": 21504,
	"./https-ssl.svg": 94538,
	"./icon-dialog.svg": 47880,
	"./ignition-off.svg": 74565,
	"./ignition-on.svg": 10513,
	"./imei.svg": 38904,
	"./img-icon.svg": 31261,
	"./in_zone.svg": 83206,
	"./input.svg": 47160,
	"./input__date.svg": 5622,
	"./input__select-2.svg": 5667,
	"./input__select-3.svg": 91026,
	"./input__select-4.svg": 24957,
	"./input__select.svg": 14290,
	"./intuit-logo.svg": 7085,
	"./item-gradient.svg": 31106,
	"./job-manager.svg": 11095,
	"./lamp.svg": 24418,
	"./line-1.svg": 55744,
	"./link.svg": 46052,
	"./list-item-1.svg": 78954,
	"./loading-dns.svg": 48526,
	"./location-point.svg": 61916,
	"./locator-icon.svg": 80068,
	"./logo.svg": 62921,
	"./maintenance.svg": 78953,
	"./maintenance_fuel.svg": 93856,
	"./maintenance_notifications.svg": 45040,
	"./maintenance_table.svg": 97872,
	"./maintenance_tracking.svg": 75807,
	"./malanka.svg": 21975,
	"./manually-start-shipment.svg": 12783,
	"./map-point-fill.svg": 65943,
	"./map-point.svg": 40059,
	"./map__car_type_ambulance.svg": 24562,
	"./map__car_type_container.svg": 85025,
	"./map__car_type_fire-fighter-woman.svg": 75289,
	"./map__car_type_fire-fighter.svg": 6140,
	"./map__car_type_flatbed.svg": 31710,
	"./map__car_type_k9.svg": 98292,
	"./map__car_type_law-men.svg": 10739,
	"./map__car_type_law-women.svg": 45693,
	"./map__car_type_motorbike.svg": 40320,
	"./map__car_type_paramedics-women.svg": 66442,
	"./map__car_type_paramedics.svg": 96391,
	"./map__car_type_pickup.svg": 20256,
	"./map__car_type_police-car.svg": 2123,
	"./map__car_type_police.svg": 62806,
	"./map__car_type_reefer.svg": 53639,
	"./map__car_type_sedan.svg": 18577,
	"./map__car_type_taxi.svg": 97568,
	"./map__car_type_trailer.svg": 61013,
	"./map__car_type_truck.svg": 97573,
	"./map__pin-bles.svg": 82660,
	"./md_fuel.svg": 74882,
	"./md_ignition.svg": 91071,
	"./md_mileage.svg": 84902,
	"./md_move.svg": 75521,
	"./md_offline.svg": 86963,
	"./md_stop.svg": 36698,
	"./md_traffic.svg": 26465,
	"./md_violations.svg": 80598,
	"./meat.svg": 86685,
	"./medicines.svg": 6567,
	"./menu-lines.svg": 71491,
	"./menu__alarm.svg": 99634,
	"./menu__alarm_fill.svg": 74982,
	"./menu__analytics.svg": 79101,
	"./menu__analytics_fill.svg": 92555,
	"./menu__car.svg": 45495,
	"./menu__car_fill.svg": 76489,
	"./menu__dashboard.svg": 66013,
	"./menu__dashboard_fill.svg": 19179,
	"./menu__dealer.svg": 50088,
	"./menu__dealer_fill.svg": 31288,
	"./menu__delete.svg": 93626,
	"./menu__delete_fill.svg": 50462,
	"./menu__driver.svg": 5497,
	"./menu__driver_fill.svg": 36879,
	"./menu__fuel.svg": 62075,
	"./menu__fuel_cards.svg": 45619,
	"./menu__fuel_cards_fill.svg": 83037,
	"./menu__fuel_fill.svg": 75797,
	"./menu__gauges.svg": 94215,
	"./menu__gauges_fill.svg": 48793,
	"./menu__geoitem_add.svg": 4519,
	"./menu__geoitems.svg": 92958,
	"./menu__geoitems_fill.svg": 71194,
	"./menu__hamburger.svg": 82468,
	"./menu__help.svg": 60346,
	"./menu__help_fill.svg": 19614,
	"./menu__history.svg": 34665,
	"./menu__history_fill.svg": 86751,
	"./menu__keys.svg": 29171,
	"./menu__keys_fill.svg": 58621,
	"./menu__maintenance.svg": 4948,
	"./menu__maintenance_fill.svg": 17292,
	"./menu__md.svg": 22664,
	"./menu__md_fill.svg": 98776,
	"./menu__more.svg": 32620,
	"./menu__more_fill.svg": 19636,
	"./menu__notifications.svg": 98129,
	"./menu__notifications_fill.svg": 5495,
	"./menu__orchestrator.svg": 45903,
	"./menu__orchestrator_fill.svg": 59505,
	"./menu__passengers.svg": 15716,
	"./menu__passengers_fill.svg": 87932,
	"./menu__personnel.svg": 40285,
	"./menu__personnel_fill.svg": 33131,
	"./menu__proHub.svg": 51401,
	"./menu__proHub2.svg": 22297,
	"./menu__proHub2_fill.svg": 3055,
	"./menu__proHub_fill.svg": 31839,
	"./menu__prometheus.svg": 43207,
	"./menu__prometheus_fill.svg": 40505,
	"./menu__reports.svg": 73260,
	"./menu__reports_fill.svg": 48596,
	"./menu__routes.svg": 44377,
	"./menu__routes_fill.svg": 99247,
	"./menu__shipment.svg": 87237,
	"./menu__shipment_fill.svg": 54531,
	"./menu__statistic.svg": 19531,
	"./menu__statistic_fill.svg": 29957,
	"./menu__tracks.svg": 72723,
	"./menu__tracks_fill.svg": 54589,
	"./menu__undefined.svg": 33693,
	"./menu__undefined_fill.svg": 11947,
	"./menu__units-groups.svg": 46149,
	"./menu__units-groups_fill.svg": 90467,
	"./menu__user-profile.svg": 46750,
	"./menu__user-profile_fill.svg": 19450,
	"./menu__video.svg": 94344,
	"./menu__video_fill.svg": 19032,
	"./microphone-available.svg": 31694,
	"./microphone-not-available.svg": 15446,
	"./microphone.svg": 91348,
	"./mileage-circle.svg": 99805,
	"./milk.svg": 36365,
	"./money_cart.svg": 26485,
	"./no-image.svg": 70845,
	"./non-alcoholic.svg": 44076,
	"./notifications__alert.sos.svg": 52643,
	"./notifications__approaching_geopoint.svg": 14922,
	"./notifications__approaching_object.svg": 54924,
	"./notifications__complex-logic.svg": 74527,
	"./notifications__distance_geopoint.svg": 17349,
	"./notifications__drain.svg": 27604,
	"./notifications__empty.svg": 48305,
	"./notifications__fuel_control.svg": 68852,
	"./notifications__geozone.entry.svg": 35765,
	"./notifications__geozone.exit.svg": 62499,
	"./notifications__geozone.svg": 79831,
	"./notifications__geozone_entrance_control.svg": 814,
	"./notifications__geozone_exit_control.svg": 28228,
	"./notifications__input-.svg": 79767,
	"./notifications__input.svg": 75294,
	"./notifications__input_alert.svg": 60985,
	"./notifications__lost-connection.svg": 75673,
	"./notifications__lost_connection.svg": 42615,
	"./notifications__low-battery.svg": 63280,
	"./notifications__maintenance.svg": 24859,
	"./notifications__max-speed.svg": 76958,
	"./notifications__movement.svg": 39037,
	"./notifications__overspeeding_gis.svg": 76961,
	"./notifications__parameter_control.svg": 91413,
	"./notifications__parking.svg": 43254,
	"./notifications__refill.svg": 5598,
	"./notifications__sensor_control.svg": 73450,
	"./notifications__stop.svg": 24402,
	"./notifications__towing.svg": 47772,
	"./notifications__video-event.svg": 75544,
	"./notifications_warning.svg": 48397,
	"./ocean.svg": 76910,
	"./ok.svg": 88794,
	"./open-new-tab.svg": 811,
	"./other.svg": 56818,
	"./output.svg": 67667,
	"./output_.svg": 4206,
	"./outputs-text-1.svg": 67164,
	"./outputs-text-2.svg": 69487,
	"./panels.svg": 73217,
	"./pen.svg": 24717,
	"./phone-circle.svg": 5021,
	"./photo.svg": 88104,
	"./play-button.svg": 57175,
	"./playback__video-event-1.svg": 53107,
	"./playback__video-event-2.svg": 62368,
	"./playback__video-event-3.svg": 19281,
	"./playback__video-group.svg": 38440,
	"./playback__warn-event.svg": 55290,
	"./pm-logo.svg": 25095,
	"./posted-speed-limit-report.svg": 76228,
	"./product_1_month.svg": 61106,
	"./product_1_year.svg": 97771,
	"./product_3_month.svg": 74288,
	"./product_6_month.svg": 41157,
	"./products_bg.svg": 85170,
	"./rail.svg": 50116,
	"./reefer-active-zone.svg": 38589,
	"./reefer-battery.svg": 77551,
	"./reefer-cooling.svg": 13621,
	"./reefer-defrost.svg": 50797,
	"./reefer-dor-close.svg": 4032,
	"./reefer-dor-open.svg": 21820,
	"./reefer-error.svg": 61706,
	"./reefer-evaporator.svg": 92277,
	"./reefer-failed.svg": 39671,
	"./reefer-heat.svg": 93414,
	"./reefer-info-1.svg": 65754,
	"./reefer-info-2.svg": 33865,
	"./reefer-info-3.svg": 29624,
	"./reefer-info-4.svg": 18807,
	"./reefer-info-5.svg": 4422,
	"./reefer-loading.svg": 21908,
	"./reefer-mode.svg": 76249,
	"./reefer-ok.svg": 22566,
	"./reefer-power-off.svg": 7683,
	"./reefer-status.svg": 14534,
	"./reefer-success.svg": 85337,
	"./reefer-supply.svg": 77257,
	"./reefer-temperature.svg": 38814,
	"./reefer-trailer.svg": 33233,
	"./reefer-wizard.svg": 11325,
	"./reefer.svg": 80591,
	"./reefer__fuel.svg": 89557,
	"./reefer__mode.svg": 58076,
	"./reefer__temperatura.svg": 71473,
	"./reefer_fish.svg": 20376,
	"./refeer__coil.svg": 88762,
	"./refeer__malanka.svg": 2842,
	"./refeer__wind.svg": 94825,
	"./repair.svg": 30875,
	"./reports.svg": 79629,
	"./reports_alarms.svg": 76902,
	"./reports_driving.svg": 75633,
	"./reports_fuel.svg": 22724,
	"./reports_idling.svg": 8175,
	"./reports_parkings.svg": 27635,
	"./reports_raw.svg": 3234,
	"./reports_statistics.svg": 53001,
	"./reports_trips.svg": 48520,
	"./road.svg": 91454,
	"./search.svg": 17928,
	"./segment__full_full_full.svg": 95762,
	"./segment__full_half_half.svg": 52226,
	"./send-to-cloud.svg": 17808,
	"./send_insurance.svg": 87843,
	"./send_sms.svg": 99384,
	"./sensor__address.svg": 3856,
	"./sensors.svg": 1433,
	"./sensors__battary_voltage.svg": 45297,
	"./sensors__battery.svg": 71022,
	"./sensors__co2_level.svg": 10054,
	"./sensors__co_level.svg": 23206,
	"./sensors__coolant_temperature.svg": 81504,
	"./sensors__cumulative_fuel_economy.svg": 13176,
	"./sensors__fuel_level.svg": 54312,
	"./sensors__humidity.svg": 70724,
	"./sensors__illumination.svg": 66998,
	"./sensors__mileage.svg": 1477,
	"./sensors__oil_pressure.svg": 43825,
	"./sensors__rpm.svg": 27558,
	"./sensors__speed.svg": 7124,
	"./sensors__temperature.svg": 29443,
	"./sensors__voltage.svg": 93499,
	"./services.svg": 52348,
	"./settings.svg": 72979,
	"./shield-done.svg": 88760,
	"./shield-wait.svg": 24883,
	"./shipment-scan-code.svg": 28238,
	"./shipment.svg": 27738,
	"./shipment__box.svg": 70183,
	"./shipment__container.svg": 94217,
	"./shipment__documents.svg": 83006,
	"./shipment__food.svg": 12664,
	"./shipment__group.svg": 20101,
	"./shipment__mail.svg": 75641,
	"./shipment__pallet.svg": 67506,
	"./shipment__pallete.svg": 30064,
	"./shipment__point.svg": 78518,
	"./shipment__temperature.svg": 90314,
	"./shipment_reports.svg": 18262,
	"./shipments-package.svg": 44778,
	"./smtp_settings.svg": 8228,
	"./sos.svg": 2181,
	"./ssl.svg": 51462,
	"./status_fuel.svg": 89269,
	"./status_mileage.svg": 72555,
	"./status_move.svg": 5078,
	"./status_none.svg": 53983,
	"./status_offline.svg": 30214,
	"./status_online.svg": 3460,
	"./status_stop.svg": 94777,
	"./status_traffic.svg": 38336,
	"./status_violations.svg": 52185,
	"./tab-fuel.svg": 27254,
	"./tag_not-registered.svg": 1535,
	"./timeline.svg": 48645,
	"./to.svg": 55767,
	"./tpms_attention.svg": 35479,
	"./tpms_temperature.svg": 80403,
	"./tpms_wheel.svg": 46152,
	"./trailer.svg": 70989,
	"./tropical-plants.svg": 69283,
	"./truck_wash.svg": 41469,
	"./unauthorized-parking-report.svg": 33628,
	"./unit-list-humidity.svg": 49699,
	"./unit-list-shock.svg": 18634,
	"./unit-list-temp.svg": 98670,
	"./unit-list-temperature.svg": 58778,
	"./unit__reefer.svg": 44715,
	"./unit_dashboard__address-point.svg": 39610,
	"./unit_dashboard__battery.svg": 88828,
	"./unit_dashboard__charge.svg": 54629,
	"./unit_dashboard__check.svg": 72195,
	"./unit_dashboard__check_danger.svg": 80171,
	"./unit_dashboard__check_null.svg": 8897,
	"./unit_dashboard__humidity.svg": 65230,
	"./unit_dashboard__ignition.svg": 71528,
	"./unit_dashboard__main_power.svg": 47596,
	"./unit_dashboard__massage.svg": 30966,
	"./unit_dashboard__mileage.svg": 24591,
	"./unit_dashboard__online.svg": 37968,
	"./unit_dashboard__speed.svg": 36398,
	"./unit_dashboard__status.svg": 76171,
	"./unit_dashboard__temperature.svg": 86113,
	"./unit_type_container.svg": 53357,
	"./unit_type_flatbed.svg": 42202,
	"./unit_type_reefer.svg": 62675,
	"./unit_type_trailer.svg": 913,
	"./unit_type_truck.svg": 54233,
	"./units-groups.svg": 51166,
	"./units__ignition_bg.svg": 14616,
	"./units__ignition_symbol.svg": 10653,
	"./units__moving_bg.svg": 19773,
	"./units__moving_symbol.svg": 6400,
	"./units__parking_bg.svg": 41677,
	"./units__parking_symbol.svg": 69520,
	"./user.svg": 65733,
	"./vaccines.svg": 26215,
	"./vector-down.svg": 97070,
	"./vector-top.svg": 33015,
	"./vegetables.svg": 67612,
	"./vide-event_cyclist-collision.svg": 28672,
	"./vide-event_distracted.svg": 95473,
	"./vide-event_pedestrian-collision.svg": 74796,
	"./video-camera.svg": 62847,
	"./video-event_acceleration.svg": 5537,
	"./video-event_accident.svg": 4030,
	"./video-event_attention.svg": 64729,
	"./video-event_braking.svg": 47383,
	"./video-event_cargo-door-closed.svg": 98913,
	"./video-event_cargo-door-open.svg": 41169,
	"./video-event_collision-warning.svg": 85824,
	"./video-event_danger-maneuver.svg": 45704,
	"./video-event_daydreaming.svg": 66530,
	"./video-event_drinking-water.svg": 29373,
	"./video-event_driver-distraction.svg": 29500,
	"./video-event_drivers-eyes-closed.svg": 97338,
	"./video-event_driving-light-hit.svg": 76097,
	"./video-event_left-turn-while-accelerating.svg": 64169,
	"./video-event_left-turn-while-decelerating.svg": 14664,
	"./video-event_left-turn.svg": 33794,
	"./video-event_no-driver.svg": 57067,
	"./video-event_no-safety-belt.svg": 97267,
	"./video-event_other.svg": 20289,
	"./video-event_over-max-speed.svg": 76452,
	"./video-event_parking-heavy-hit.svg": 16205,
	"./video-event_power-lost.svg": 24351,
	"./video-event_right-turn-while-accelerating.svg": 31046,
	"./video-event_right-turn-while-decelerating.svg": 66519,
	"./video-event_right-turn.svg": 25715,
	"./video-event_sign-violation.svg": 6288,
	"./video-event_smoking.svg": 76081,
	"./video-event_speeding.svg": 83514,
	"./video-event_swerve.svg": 16081,
	"./video-event_talking-on-cell-phone.svg": 5797,
	"./video-event_traffic-light-violation.svg": 31129,
	"./video-event_turn.svg": 17252,
	"./video-event_yawning.svg": 85316,
	"./video-full.svg": 16381,
	"./video-play-popup.svg": 22637,
	"./video-play.svg": 83416,
	"./video-request_done.svg": 53628,
	"./video-request_event.svg": 94196,
	"./video-request_loading.svg": 74952,
	"./video-request_smart-search-accident.svg": 66082,
	"./video-small.svg": 50975,
	"./video-stop.svg": 60202,
	"./video__camera-current.svg": 2906,
	"./video__camera.svg": 36722,
	"./view-document.svg": 37891,
	"./warning-outline.svg": 1193,
	"./warning.svg": 70216,
	"./weather__cloudy-2.svg": 19283,
	"./weather__cloudy.svg": 85826,
	"./weather__day-cloudy-1.svg": 76187,
	"./weather__day-cloudy-2.svg": 60648,
	"./weather__day-cloudy-3.svg": 73017,
	"./weather__day-mostlyc-2.svg": 11185,
	"./weather__day-mostlyc-3.svg": 96800,
	"./weather__day-mostlyc.svg": 41900,
	"./weather__day-rainy-1.svg": 9774,
	"./weather__day-rainy-2.svg": 38893,
	"./weather__day-rainy-3.svg": 59180,
	"./weather__day-snowy-1.svg": 7499,
	"./weather__day-snowy-2.svg": 68664,
	"./weather__day-snowy-3.svg": 27817,
	"./weather__day-thunder-rainy-2.svg": 87896,
	"./weather__day-thunder-rainy-3.svg": 63401,
	"./weather__day-thunder-rainy-4.svg": 36518,
	"./weather__day-thunder.svg": 99713,
	"./weather__day.svg": 34956,
	"./weather__empty.svg": 30481,
	"./weather__night-cloudy-1.svg": 54679,
	"./weather__night-cloudy-2.svg": 228,
	"./weather__night-cloudy-3.svg": 97477,
	"./weather__night-mostlyc-2.svg": 62549,
	"./weather__night-mostlyc-3.svg": 24564,
	"./weather__night-mostlyc.svg": 86904,
	"./weather__night-rainy-1.svg": 14746,
	"./weather__night-rainy-2.svg": 40329,
	"./weather__night-rainy-3.svg": 64824,
	"./weather__night-snowy-1.svg": 45639,
	"./weather__night-snowy-2.svg": 97428,
	"./weather__night-snowy-3.svg": 19061,
	"./weather__night-thunder-rainy-2.svg": 36820,
	"./weather__night-thunder-rainy-3.svg": 74805,
	"./weather__night-thunder-rainy-4.svg": 45706,
	"./weather__night-thunder-rainy.svg": 6821,
	"./weather__night-thunder.svg": 7877,
	"./weather__night.svg": 60320,
	"./weather__precip.svg": 57671,
	"./weather__pressure.svg": 32203,
	"./weather__raindrop.svg": 71339,
	"./weather__rainy-2.svg": 63012,
	"./weather__rainy-3.svg": 17733,
	"./weather__rainy-4.svg": 6106,
	"./weather__rainy.svg": 61621,
	"./weather__snowy-1.svg": 2166,
	"./weather__snowy-2.svg": 15125,
	"./weather__snowy-3.svg": 70196,
	"./weather__snowy-rainy-1.svg": 74498,
	"./weather__snowy-rainy-2.svg": 15249,
	"./weather__snowy-rainy-3.svg": 17216,
	"./weather__snowy-rainy-4.svg": 18335,
	"./weather__thermometer.svg": 19262,
	"./weather__thunder-rainy-2.svg": 87173,
	"./weather__thunder-rainy-3.svg": 32452,
	"./weather__thunder-rainy-4.svg": 94603,
	"./weather__thunder-rainy.svg": 52104,
	"./weather__thunder.svg": 59028,
	"./weather__weather.svg": 75874,
	"./weather__wind.svg": 62324,
	"./wi-fi.svg": 92650,
	"./wizard-info.svg": 20326,
	"./wizard-key.svg": 40947,
	"./wizard-sensors.svg": 36479,
	"./wizard-settings.svg": 23557,
	"./write-edit.svg": 44930,
	"./xRoute.svg": 6979,
	"./xtype_checkbox.svg": 23628,
	"./xtype_pro_vision.svg": 94063,
	"./xtype_xcargo.svg": 51523,
	"./xtype_xcargo_vision.svg": 18462,
	"./xtype_xcool.svg": 73514,
	"./xtype_xtag.svg": 1563,
	"./xtype_xtrack.svg": 36638,
	"./xtype_xtrack_asset.svg": 32939,
	"./xtype_xwaste.svg": 59061,
	"./yogurt.svg": 48410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;